import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";

import { PostHogProvider } from "@posthog/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/toast";
import { analytics, initAnalytics } from "@/lib/analytics";
import { queryClient } from "@/lib/query-client";
import App from "./App.tsx";

// Spec 39: init PostHog before render; provider exposes the client to the
// usePostHog / feature-flag hooks. The identity bridge lives in RootLayout.
initAnalytics();

// biome-ignore lint/style/noNonNullAssertion: it's fine here
createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<PostHogProvider client={analytics.client}>
			<QueryClientProvider client={queryClient}>
				<App />
				<Toaster />
			</QueryClientProvider>
		</PostHogProvider>
	</StrictMode>,
);
